<template>
  <button class="button-pill"><slot></slot></button>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ButtonPill",
});
</script>
<style scoped>
.button-pill {
  width: auto;
  position: relative;
  backdrop-filter: blur(32px);
  border-radius: 16px;
  background: linear-gradient(1.64deg, #202b40, rgba(12, 17, 26, 0));
  border: 1px solid #233452;
  box-sizing: border-box;
  padding: 0.5em;
  white-space: nowrap;
  color: white;
  font-weight: 300;
  font-size: 0.8em;
  outline: none;
  &:hover {
    filter: brightness(1.5);
  }
  &.active {
    background: rgba(255, 255, 255, 0.18);
    font-weight: bold;
  }
  &:highlight {
    background: rgba(255, 255, 255, 0.18);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
}

@media (min-width: 1920px) {
  .button-pill{
    font-size: 0.8vw;
    padding: 0.5vw;
  }
}

@media (min-width: 3840px) {
  .button-pill{
    font-size: 1.8em;
    padding: 0.8em;
  }
}
</style>
